import IngredientDetails from '../components/ingredient-details/ingredient-details';
import Wrapper from '../components/common/wrapper/wrapper';

export const IngredientPage = () => {
  return (
    <Wrapper>
      <IngredientDetails />
    </Wrapper>
  );
};
